import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import FormyTooltip from "./Tooltip";

export default observer((props) => {
  const store = useLocalObservable(() => ({some_prop: ''}));
  useEffect(() => {
    // mount
    return () => {
      // unmount
    }
  }, []);

  return (
    <div className="up12 splice">
      <div className="cell s-12 m-shrink s-middle only-s-pbottom10">
        <div style={{width:270}} className="fs14">
          {props.title} {props.tooltip?<FormyTooltip text={props.tooltip}><span className="mdi mdi-information-outline pc1"></span></FormyTooltip>:null}
        </div>
      </div>
      <div className="cell s-12 m-auto s-middle">
        {props.children}
      </div>
    </div>
  )

});